import { render } from "./EmailEditor.vue?vue&type=template&id=3fd595bf&scoped=true&ts=true"
import script from "./EmailEditor.vue?vue&type=script&lang=ts"
export * from "./EmailEditor.vue?vue&type=script&lang=ts"

import "./EmailEditor.vue?vue&type=style&index=0&id=3fd595bf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fd595bf"]])

export default __exports__